module.exports = __webpack_public_path__ + "static/media/success-sound.1768de81.mp3";